// Estatus
const ESTATUS_ACTIVO = "A";
const ESTATUS_ACTIVO_LABEL = "Activo";
const ESTATUS_INACTIVO = "I";
const ESTATUS_INACTIVO_LABEL = "Inactivo";

// Tipo Venta
const TIPO_VENTA_CONTADO = "P";
const TIPO_VENTA_CREDITO = "C";
const TIPO_VENTA_TODOS = "T";
const TIPO_VENTA_CONTADO_LABEL = "Contado";
const TIPO_VENTA_CREDITO_LABEL = "Crédito";
const TIPO_VENTA_TODOS_LABEL = "Todos";

// Configuración
const TIPO_FACTURACION_RETAIL = "R";
const TIPO_FACTURACION_GASOLINERA = "G";
const TIPO_FACTURACION_RETAIL_LABEL = "Retail";
const TIPO_FACTURACION_GASOLINERA_LABEL = "Gasolinera";


export class TerminalPOS {
    static get ESTATUS_LIST() {
        return [
            { value: ESTATUS_ACTIVO, label: ESTATUS_ACTIVO_LABEL },
            { value: ESTATUS_INACTIVO, label: ESTATUS_INACTIVO_LABEL },
        ];
    }

    static get TIPO_VENTA_LIST() {
        return [
            { value: TIPO_VENTA_CONTADO, label: TIPO_VENTA_CONTADO_LABEL },
            { value: TIPO_VENTA_CREDITO, label: TIPO_VENTA_CREDITO_LABEL },
            { value: TIPO_VENTA_TODOS, label: TIPO_VENTA_TODOS_LABEL }
        ];
    }

    static get TIPO_FACTURACION_LIST() {
        return [
            { value: TIPO_FACTURACION_RETAIL, label: TIPO_FACTURACION_RETAIL_LABEL },
            { value: TIPO_FACTURACION_GASOLINERA, label: TIPO_FACTURACION_GASOLINERA_LABEL }
        ];
    }

    static get DEFAULT_ESTATUS_VALUE() {
        return ESTATUS_ACTIVO;
    }

    static get PROPIEDADES_EXPORTAR() {
        const propiedades = [
            { value: "IdSec", label: "Id" },
            { value: "Nombre", label: "Nombre" },
            { value: "EstatusDesc", label: "Estatus" },
            { value: "CrearUsuario", label: "Crear Usuario" },
            { value: "FechaCreacion", label: "Fecha Creación" },
            { value: "ActualizarUsuario", label: "Actualizar Usuario" },
            { value: "FechaActualizacion", label: "Fecha Actualización" },
        ];
        return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
    }
}
